import { MonitoringOfferPage, MonitoringOfferPageSpecialist } from '@features/monitoringOffer';
import { useLocation } from 'react-router-dom';
export const MonitoringOffer = () => {
	const isFarmerPath = useLocation().pathname.includes('farmer');

	return (
		<div className="w-full h-full md:max-w-[1440px] md:mx-auto md:px-5">
			{isFarmerPath ? <MonitoringOfferPage /> : <MonitoringOfferPageSpecialist />}
		</div>
	);
};
